import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-screen w-screen" }
const _hoisted_2 = { class: "flex justify-content-center flex-grow" }
const _hoisted_3 = { class: "flex flex-col flex-grow px-20 min-h-full bg-slate-100" }
const _hoisted_4 = { class: "bg-white flex-grow mb-6 h-100 rounded-md" }

import TopBar from '@/components/TopBar/TopBar.vue'
import LandingHeader from '@/features/landing/components/LandingHeader.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HelpLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(LandingHeader),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createBlock(_component_router_view, {
            key: _ctx.$route.fullPath
          }))
        ])
      ])
    ])
  ]))
}
}

})